import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminSideMenu from '../components/UI/AdminSideMenu/AdminSideMenu';
import styles from './Analytics.module.css';
import { Box, Grid, Card, CardContent, Typography, TextField, Select, MenuItem, Button, CircularProgress } from '@mui/material';

const ReferralDashboard = () => {
  const token = sessionStorage?.getItem('afd8TvhsdjwiuuvsgjhsAfgsUhjs');
  const [q, setQ] = useState('');
  const [currency, setCurrency] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(200);
  const [product, setProduct] = useState('');
  const [duration, setDuration] = useState('');
  const [onlyWithReferrals, setOnlyWithReferrals] = useState(false);
  const [onlyWithVerifiedPayout, setOnlyWithVerifiedPayout] = useState(false);
  const [activeTab, setActiveTab] = useState('entries'); // 'entries' | 'payouts'
  const [refPage, setRefPage] = useState(1);
  const [refLimit, setRefLimit] = useState(50);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ kpis: {}, referrers: { rows: [], total: 0 }, entries: { rows: [], total: 0 } });

  useEffect(() => {
  const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (currency) params.set('currency', currency);
    if (startDate) params.set('startDate', startDate);
    if (endDate) params.set('endDate', endDate);
  if (product) params.set('product', product);
  if (duration) params.set('duration', duration);
  if (onlyWithReferrals) params.set('onlyWithReferrals', 'true');
  if (onlyWithVerifiedPayout) params.set('onlyWithVerifiedPayout', 'true');
    params.set('page', String(page));
    params.set('limit', String(limit));
    params.set('refPage', String(refPage));
    params.set('refLimit', String(refLimit));
    const url = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', url);
  }, [q, currency, startDate, endDate, product, duration, onlyWithReferrals, onlyWithVerifiedPayout, page, limit, refPage, refLimit]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
  setQ(urlParams.get('q') || '');
    setCurrency(urlParams.get('currency') || '');
    setStartDate(urlParams.get('startDate') || '');
    setEndDate(urlParams.get('endDate') || '');
    setProduct(urlParams.get('product') || '');
    setDuration(urlParams.get('duration') || '');
    setOnlyWithReferrals(urlParams.get('onlyWithReferrals') === 'true');
    setOnlyWithVerifiedPayout(urlParams.get('onlyWithVerifiedPayout') === 'true');
    setPage(parseInt(urlParams.get('page') || '1', 10));
    setLimit(parseInt(urlParams.get('limit') || '200', 10));
    setRefPage(parseInt(urlParams.get('refPage') || '1', 10));
    setRefLimit(parseInt(urlParams.get('refLimit') || '50', 10));
  }, []);

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();
        if (q) params.set('q', q);
        if (currency) params.set('currency', currency);
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if (product) params.set('product', product);
        if (duration) params.set('duration', duration);
        if (onlyWithReferrals) params.set('onlyWithReferrals', 'true');
        if (onlyWithVerifiedPayout) params.set('onlyWithVerifiedPayout', 'true');
        params.set('page', String(page));
        params.set('limit', String(limit));
        params.set('refPage', String(refPage));
        params.set('refLimit', String(refLimit));

        const resp = await axios.get(`/origin/get-referrals?${params.toString()}`, { headers: { 'x-access-token': token } });
        setData(resp.data || { kpis: {}, referrers: { rows: [], total: 0 }, entries: { rows: [], total: 0 } });
      } catch (e) {
        // no-op
      } finally {
        setLoading(false);
      }
    };
    fetchReferrals();
  }, [q, currency, startDate, endDate, product, duration, onlyWithReferrals, onlyWithVerifiedPayout, page, limit, refPage, refLimit, token]);

  const k = data.kpis || {};
  const refRows = data.referrers?.rows || [];
  const refTotal = data.referrers?.total || 0;
  const entRows = data.entries?.rows || [];
  const entTotal = data.entries?.total || 0;

  return (
    <div className={styles.analyticsContainer}>
      <AdminSideMenu />
      <div className={styles.analyticsContent}>
        <Box className={styles.analyticsHeader}>
          <Box className={styles.headerLeft}>
            <Typography variant="h4" className={styles.pageTitle}>Referrals Dashboard</Typography>
            <Typography variant="subtitle1" className={styles.pageSubtitle}>Track referral activity, earnings, and payouts</Typography>
          </Box>
        </Box>

        {loading ? (
          <Box className={styles.loadingContainer}>
            <CircularProgress />
            <Typography variant="body1" sx={{ mt: 2 }}>
              Loading referrals data...
            </Typography>
          </Box>
        ) : (
          <>
            {/* KPIs */}
            <Grid container spacing={2} className={styles.kpiContainer}>
              <Grid item xs={12} sm={6} md={3}>
                <Card className={styles.kpiCard} sx={{ background: '#ffffff' }}>
                  <CardContent>
                    <Typography className={styles.kpiLabel}>Total Referrers</Typography>
                    <Typography className={styles.kpiValue}>{k.totalReferrers || 0}</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card className={styles.kpiCard} sx={{ background: '#ffffff' }}>
                  <CardContent>
                    <Typography className={styles.kpiLabel}>Total Referred</Typography>
                    <Typography className={styles.kpiValue}>{k.totalReferredUsers || 0}</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card className={styles.kpiCard} sx={{ background: '#ffffff' }}>
                  <CardContent>
                    <Typography className={styles.kpiLabel}>Total Earnings</Typography>
                    <Typography className={styles.kpiValue}>{(k.totalEarnings || 0).toLocaleString()}</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card className={styles.kpiCard} sx={{ background: '#ffffff' }}>
                  <CardContent>
                    <Typography className={styles.kpiLabel}>Entries (filtered)</Typography>
                    <Typography className={styles.kpiValue}>{k.rangeEntriesCount || 0}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Tabs: Entries / Payouts */}
            <Box sx={{ background: '#fff', p: 1, borderRadius: 2, mb: 2, display: 'flex', gap: 1 }}>
              <Button variant={activeTab === 'entries' ? 'contained' : 'text'} onClick={() => setActiveTab('entries')}>Earning Entries</Button>
              <Button variant={activeTab === 'payouts' ? 'contained' : 'text'} onClick={() => setActiveTab('payouts')}>Payouts</Button>
            </Box>

            {/* Earnings entries table */}
            <Box className={styles.chartContainer} sx={{ p: 0 }}>
              <div style={{ padding: 16 }}>
                <Typography variant="h6">Earning Entries</Typography>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#c0d1d457' }}>
                        <th style={{ textAlign: 'left', padding: 8 }}>Referrer</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Referred</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Product</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Duration</th>
                        <th style={{ textAlign: 'right', padding: 8 }}>Settled</th>
                        <th style={{ textAlign: 'right', padding: 8 }}>Commission</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Currency</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Tx Ref</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Date</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Due</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Paid</th>
                      </tr>
                    </thead>
                    <tbody>
                      {entRows.map((e, idx) => (
                        <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: 8 }}>{e.referrer?.name} <span style={{ color: '#666' }}>({e.referrer?.email})</span></td>
                          <td style={{ padding: 8 }}>{e.referredUser?.name} <span style={{ color: '#666' }}>({e.referredUser?.email})</span></td>
                          <td style={{ padding: 8 }}>{e.subscription}</td>
                          <td style={{ padding: 8 }}>{e.duration}</td>
                          <td style={{ padding: 8, textAlign: 'right' }}>{Number(e.amountSettled || 0).toLocaleString()}</td>
                          <td style={{ padding: 8, textAlign: 'right' }}>{Number(e.commissionAmount || 0).toLocaleString()}</td>
                          <td style={{ padding: 8 }}>{e.currency}</td>
                          <td style={{ padding: 8 }}>{e.tx_ref}</td>
                          <td style={{ padding: 8 }}>{new Date(e.createdAt).toLocaleString()}</td>
                          <td style={{ padding: 8 }}>{e.payoutDueAt ? new Date(e.payoutDueAt).toLocaleString() : '-'}</td>
                          <td style={{ padding: 8 }}>{e.paid ? 'Yes' : 'No'}</td>
                        </tr>
                      ))}
                      {entRows.length === 0 && (
                        <tr><td colSpan={9} style={{ padding: 8, color: '#666' }}>No entries</td></tr>
                      )}
                    </tbody>
                  </table>
                  <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    <Typography variant="body2">Page {page}</Typography>
                    <Button size="small" variant="outlined" disabled={page <= 1 || loading} onClick={() => setPage((p) => Math.max(1, p - 1))}>Prev</Button>
                    <Button size="small" variant="outlined" disabled={(page * limit) >= entTotal || loading} onClick={() => setPage((p) => p + 1)}>Next</Button>
                    <Select size="small" value={String(limit)} onChange={(e) => { setLimit(parseInt(e.target.value, 10)); setPage(1); }}>
                      {[100, 200, 500, 1000].map(n => <MenuItem key={n} value={String(n)}>{n}/page</MenuItem>) }
                    </Select>
                  </Box>
                </div>
              </div>
            </Box>

            {/* Filters */}
            <Box display="flex" gap={2} alignItems="center" sx={{ background: '#fff', p: 2, borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <TextField size="small" placeholder="Search referrer (name/email)" value={q} onChange={(e) => { setQ(e.target.value); setRefPage(1); setPage(1); }} />
              <Select size="small" value={currency} onChange={(e) => { setCurrency(e.target.value); setPage(1); }} displayEmpty>
                <MenuItem value=""><em>Any Currency</em></MenuItem>
                <MenuItem value="NGN">NGN</MenuItem>
                <MenuItem value="USD">USD</MenuItem>
                <MenuItem value="EUR">EUR</MenuItem>
              </Select>
              <TextField size="small" placeholder="Product" value={product} onChange={(e) => { setProduct(e.target.value); setPage(1); }} />
              <TextField size="small" placeholder="Duration" value={duration} onChange={(e) => { setDuration(e.target.value); setPage(1); }} />
              <TextField size="small" type="date" value={startDate} onChange={(e) => { setStartDate(e.target.value); setPage(1); }} />
              <TextField size="small" type="date" value={endDate} onChange={(e) => { setEndDate(e.target.value); setPage(1); }} />
              <Button variant="outlined" onClick={() => { setQ(''); setCurrency(''); setStartDate(''); setEndDate(''); setProduct(''); setDuration(''); setOnlyWithReferrals(false); setPage(1); setRefPage(1); }}>Reset</Button>
            </Box>

            {/* Referrers table (moved below entries) */}
            <Box className={styles.chartContainer} sx={{ p: 0 }}>
              <div style={{ padding: 16 }}>
                <Typography variant="h6">Referrers</Typography>
                <Box display="flex" alignItems="center" gap={2} mb={1}>
                  <Select size="small" value={onlyWithReferrals ? 'true' : ''} displayEmpty onChange={(e) => { setOnlyWithReferrals(e.target.value === 'true'); setRefPage(1); }}>
                    <MenuItem value=""><em>All Users</em></MenuItem>
                    <MenuItem value="true">Only With Referrals</MenuItem>
                  </Select>
                  <Select size="small" value={onlyWithVerifiedPayout ? 'true' : ''} displayEmpty onChange={(e) => { setOnlyWithVerifiedPayout(e.target.value === 'true'); setRefPage(1); }}>
                    <MenuItem value=""><em>Any Payout Status</em></MenuItem>
                    <MenuItem value="true">Only With Verified Payout</MenuItem>
                  </Select>
                </Box>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#c0d1d457' }}>
                        <th style={{ textAlign: 'left', padding: 8 }}>Name</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Email</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Code</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Payout Provider</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Payout Status</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Payouts Enabled</th>
                        <th style={{ textAlign: 'right', padding: 8 }}>Referred</th>
                        <th style={{ textAlign: 'right', padding: 8 }}>Total Earned</th>
                        <th style={{ textAlign: 'right', padding: 8 }}>Range Earned</th>
                        <th style={{ textAlign: 'left', padding: 8 }}>Last Earned</th>
                      </tr>
                    </thead>
                    <tbody>
                      {refRows.map((r, idx) => (
                        <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: 8 }}>{r.name}</td>
                          <td style={{ padding: 8 }}>{r.email}</td>
                          <td style={{ padding: 8 }}>{r.referralCode || '-'}</td>
                          <td style={{ padding: 8 }}>{r.payout?.provider || '-'}</td>
                          <td style={{ padding: 8 }}>{r.payout?.status || '-'}</td>
                          <td style={{ padding: 8 }}>{r.payout?.payoutsEnabled ? 'Yes' : 'No'}</td>
                          <td style={{ padding: 8, textAlign: 'right' }}>{r.referredCount}</td>
                          <td style={{ padding: 8, textAlign: 'right' }}>{Number(r.totalEarnings || 0).toLocaleString()}</td>
                          <td style={{ padding: 8, textAlign: 'right' }}>{Number(r.rangeEarnings || 0).toLocaleString()}</td>
                          <td style={{ padding: 8 }}>{r.lastEarnedAt ? new Date(r.lastEarnedAt).toLocaleString() : '-'}</td>
                        </tr>
                      ))}
                      {refRows.length === 0 && (
                        <tr><td colSpan={10} style={{ padding: 8, color: '#666' }}>No referrers found</td></tr>
                      )}
                    </tbody>
                  </table>
                  <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    <Typography variant="body2">Page {refPage}</Typography>
                    <Button size="small" variant="outlined" disabled={refPage <= 1 || loading} onClick={() => setRefPage((p) => Math.max(1, p - 1))}>Prev</Button>
                    <Button size="small" variant="outlined" disabled={(refPage * refLimit) >= refTotal || loading} onClick={() => setRefPage((p) => p + 1)}>Next</Button>
                    <Select size="small" value={String(refLimit)} onChange={(e) => { setRefLimit(parseInt(e.target.value, 10)); setRefPage(1); }}>
                      {[25, 50, 100, 200].map(n => <MenuItem key={n} value={String(n)}>{n}/page</MenuItem>) }
                    </Select>
                  </Box>
                </div>
              </div>
            </Box>
          </>
        )}
      </div>
    </div>
  );
};

export default ReferralDashboard;
